<template>
  <v-app>
    <v-container>
      <v-layout row v-if="error">
        <v-flex xs12 sm6 offset-sm3>
          <v-alert :value="error" color="error">
            <v-btn icon><v-icon @click="onDismissed">close</v-icon></v-btn> {{error.message}}
          </v-alert>
        </v-flex>
      </v-layout>
      <!-- <v-layout row justify-center align-center>
        <v-flex xs12 py-4 class="text-xs-center">
          <v-img src="/static/final.png" class="h-center" max-width="320px" />
        </v-flex>
      </v-layout> -->
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-card>
            <v-card-text>
              <v-container>
                <v-form @submit.prevent="changePassword" ref="form" v-model="valid" lazy-validation>
                  <v-layout row>
                    <v-flex xs12>
                        <v-text-field name="login" label="Login" id="login" v-model="login" required :rules="[v => !!v || 'Debe ingresar el Login del Usuario']"></v-text-field>

                        <v-text-field 
                            v-model="currentPassword"
                            v-validate="'required'"
                            :error-messages="errors.collect('currentPassword')"
                            data-vv-name="currentPassword"                            
                            type="password"
                            placeholder="Contraseña actual"
                            v-if="currentPassVisible">       
                        </v-text-field>
                    </v-flex>
                  </v-layout>  

                  <v-layout row>
                    <v-flex xs12>
                        <v-text-field 
                            v-model="newPassword"
                            required
                            :rules="passwordRules"
                            type="password" 
                            placeholder="Nueva Contraseña">
                            <!-- <span v-show="errors.has('newPassword')" class="help is-danger">{{ errors.first('password') }}</span> -->
                        </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex xs12>
                        <v-text-field  
                            v-model="passwordValidation"
                            required
                            :rules="passwordRules"
                            type="password"
                            placeholder="Repita la nueva contraseña." 
                            >
                        </v-text-field>
                    </v-flex>
                  </v-layout>
                  
              
                  
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field 
                        v-model="codigoValidacion"
                        required
                        :rules="[v => !!v || 'Debe ingresar el código de validación']"
                        label="Código de Validación" 
                        placeholder="Ingrese el código de validación enviado por correo electrónico">
                      </v-text-field>
                    </v-flex>
                  <v-layout row></v-layout>                    
                    <v-flex xs12>
                      <v-btn type="submit" :disabled="loading" :loading="loading">
                        Confirmar
                        <span slot="loader" class="custom-loader">
                          <v-icon light>cached</v-icon>
                        </span>
                      </v-btn>
                    </v-flex>

                     <template v-if="$store.state.debugModeOn">
                            Debug Info: <p></p>
                            
                             Model: {{login}},{{newPassword}},{{passwordValidation}}
                    </template>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>



<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import { http } from '@/axios'

export default {
  
  data () {
    return {
      unverified: true,
      currentPassword: '',
      newPassword: '',
      passwordValidation:'',
      codigoValidacion:'',
      props: {
              login: String,
              currentPassVisible: Boolean,
      },
      passwordRules: [
        v => !!v || 'Ingrese la contraseña',
        v => (v && v.length >= 4) || 'La contraseña debe tener al menos 4 caracteres',
      ],
    }
  },
  computed: {
    ...mapGetters([ 'user', 'error', 'loading' ])
  },
  watch: {
    user (value) {
       Vue.$log.debug(value);
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      } else {
        // this.$router.push('/')
      }
    }
  },
  created() {
    this.login = this.$route.params.login;
    this.currentPassVisible = this.$route.params.currentPassVisible;
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    async changePassword ({ dispatch, commit }, payload) {
      
      if (!this.$refs.form.validate()) {
          return;
      }

    try {
      await http.put('usuarios/cambiarclave', { "usuario": {
        "login": this.login,
        "password": this.newPassword,
        "passwordvalidation": this.passwordValidation,
        "codigoValidacion": this.codigoValidacion
      } })

      this.alertSuccess('La nueva clave ha sido guardada. Se procederá al ingreso a SmarterFinancial...')

      this.$store.dispatch('signUserIn', { usuario: this.login, password: this.newPassword })

    } catch (e) { 
      Vue.$log.debug(e);
      this.alertError(e)
    }
  
    
  },
    onSignin () {
      this.$store.dispatch('signUserIn', { usuario: this.usuario, password: this.password })
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    onVerify (response) { this.unverified = false },
    onExpired () { this.unverified = true }
  }
}
</script>

<style scoped>
@media screen and (max-width: 450px) {
  #rc-imageselect, .g-recaptcha {
    transform:scale(0.77);-webkit-transform:scale(0.77);transform-origin:0 0;-webkit-transform-origin:0 0;
  }
}
.center-all {
  display: flex;
  align-items: center; /* v */
  justify-content: center; /* h */
}
.h-center {
  margin-left: auto;
  margin-right: auto;
}
</style>